<template>
  <div
    :style="{height}"
    class="position-relative"
  >
    <v-img
      :height="$store.state.mobile ? 245 : 465"
      :src="require('@/assets/img-news-letter.jpg')"
    />
    <div class="box white--text">
      <v-container
        fill-height
        class="font-medium  text-center"
      >
        <v-row
          justify="center"
          align="center"
        >
          <v-col
            cols="10"
            sm="7"
          >
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <div
                style="font-size:48px;text-shadow:1px 1px 2px rgba(0,0,0,.3)"
                class="text-uppercase"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  اترك رسالة بريد إلكتروني
                </template>
                <template v-else>
                  Newsletter
                </template>
              </div>
              <div
                class="font-medium text-h5 mb-4"
                style="line-height:1.2"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  اشترك في نشرتنا الإخبارية وكن دائمًا أول من يسمع بما يحدث.
                </template>
                <template v-else>
                  Subscribe to our newsletter and always be the first to hear about what is happening.
                </template>
              </div>
              <v-card elevation="0">
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  :dense="$store.state.mobile"
                  :loading="submitting"
                  type="email"
                  clearable
                  solo
                  flat
                  class="rounded-0"
                  :placeholder="$store.getters.languageGetter === '1' ? 'أدخل عنوان بريدك الالكتروني' : 'Enter your email address' "
                  hide-details
                  append-icon="mdi-arrow-right"
                  @click:append="addNewsLetter"
                />
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'NewsLetter',
  data() {
    return {
      valid: true,
      submitting: false,
      height: this.$store.state.breakpoint.mobile ? '245px' : '465px',
      email: '',
      emailRules: [(v) => !!v || 'Please enter your email', (v) => /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(v)
          || 'This is not a correct email address'],
    };
  },
  methods: {
    ...mapActions(['addNewsLetterAsync']),
    addNewsLetter() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.addNewsLetterAsync({ email: this.email }).then(() => {
          this.email = '';
        }).finally(() => {
          this.submitting = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>
